import React from 'react';
import { Box, Typography } from '@mui/material';
import { ClientField } from 'shared/types/appTypes';
import { FormFieldRenderer } from 'src/ui-components/form-fields';

interface FormQuestionProps {
  field: ClientField;
  questionNumber: number;
  value: any;
  onChange: (value: any) => void;
  disabled?: boolean;
}

const FormQuestion: React.FC<FormQuestionProps> = ({
  field,
  value,
  onChange,
  disabled,
}) => {
  const showQuestion = 'question' in field && (field.question || field.label);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: showQuestion ? 2 : 1,
        width: '100%',
      }}
    >
      {/* Question */}
      {showQuestion && (
        <Box sx={{ width: '100%', textAlign: 'center' }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 500,
              lineHeight: 1.3,
              mb: 1,
              fontSize: { xs: '1.25rem', sm: '1.5rem' },
            }}
          >
            {'question' in field && (field.question || field.label)}
          </Typography>
          {'helperText' in field && field.helperText && (
            <Typography
              variant="body2"
              sx={{
                color: 'text.secondary',
                mt: 1,
                fontSize: { xs: '0.875rem', sm: '1rem' },
              }}
            >
              {field.helperText}
            </Typography>
          )}
        </Box>
      )}

      {/* Input */}
      <Box sx={{ width: '100%', mt: showQuestion ? 2 : 1 }}>
        <FormFieldRenderer
          field={field}
          value={value}
          onChange={onChange}
          autoFocus={!disabled}
          disabled={disabled}
        />
      </Box>
    </Box>
  );
};

export default FormQuestion;
